import React, { useRef, useEffect } from 'react';

const DomChildren = (props) => {
  const ref = useRef();

  useEffect(() => {
    if(!props.children_node) return;

    while (ref.current.firstChild) { 
      ref.current.removeChild(ref.current.firstChild); 
    }

    ref.current.appendChild(props.children_node)

  }, [props.children, ref.current]);

  return (
      <react_rails_children ref={ref} />
  )
}

export default DomChildren;